import { Post } from "../../../../types/features/Post";
import TableList, { SelectAction } from "../../../ui/TableList";
import PostRow from "./PostRow";

interface PostsListProps {
  posts: Post[];
  onAction: (post: Post) => void;
  onSelectPosts?: (selectedPosts: Post[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function PostsList({
  posts,
  onAction,
  onSelectPosts,
  selectable = false,
  selectActions,
}: PostsListProps) {
  const columns = [
    { header: "Article", className: "w-2/5" },
    { header: "Catégorie", className: "hidden sm:table-cell w-1/5" },
    { header: "Auteur", className: "hidden sm:table-cell w-1/5" },
    { header: "Statut", className: "hidden md:table-cell w-1/6" },
  ];

  return (
    <TableList
      items={posts}
      columns={columns}
      getId={(post) => post.id}
      onAction={onAction}
      onSelectItems={onSelectPosts}
      selectable={selectable}
      emptyMessage="Aucun article trouvé"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(post, isSelected, onSelect) => (
        <PostRow
          key={post.id}
          post={post}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}
